module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  limit=\"$ctrl.limit\"\n  resource=\"TravelRequest\"\n  item-state=\"travelrequest\"\n  title=\"Travel Requests\"\n  transformer=\"TravelRequestsTransforms\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  no-items-text=\"No Travel Requests Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/travelRequests/travelRequests.html
// module id = 1919
// module chunks = 0